import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Products from "@/components/Products";
import CaseStudies from "@/components/CaseStudies";
import Manifesto from "@/components/Manifesto";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Chatbot from "@/components/Chatbot";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Home() {
  return (
    <>
      <Navbar />
      <main className="relative z-[2]">
        <Hero />
        <Marquee />
        <Services />
        <Products />
        <CaseStudies />
        <Manifesto />
        <About />
        <Contact />
      </main>
      <Footer />
      <Chatbot />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <div className="App dark grain bg-[#050505]" data-testid="app-root">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
          </Routes>
          <Toaster position="top-center" theme="dark" />
        </div>
      </ReactLenis>
    </BrowserRouter>
  );
}

export default App;
